import {
  Component,
  OnInit,
  Input,
  OnChanges,
  EventEmitter,
  Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Table, TableModule } from "primeng/table";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { SampleData } from "../../../../core/models/bcLedgers/sample/SampleData";
import { SampleRequestDto } from "../../../../core/models/bcLedgers/sample/SampleRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { MoveToFreightComponent } from "../move-to-freight/move-to-freight.component";
import { CommonModule } from "@angular/common";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { FreightsData } from "../../../../core/models/bcLedgers/freightsResponseDto";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";

@UntilDestroy()
@Component({
  selector: "jni-sample",
  templateUrl: "./sample.component.html",
  styleUrls: ["./sample.component.scss"],
  imports: [
    MoveToFreightComponent,
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    InputTextModule,
    ButtonModule,
  ],
})
export class SampleComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  sampleLists: SampleData[] = [];
  bcledgerFilter!: SampleRequestDto;
  sampleSelected!: FreightsData;
  display = false;
  total!: number;
  fileName = "Sample";
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _route: ActivatedRoute,
    private _sampleService: BcledgerService,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService
  ) {
    this._route.params.subscribe(params => {
      this.bcledgerFilter = { ...params } as SampleRequestDto;
    });
  }

  ngOnInit(): void {
    this.getSampleData();
  }

  getSampleData() {
    this._loaderService.setLoaderState(true);
    this._sampleService
      .getSampleData(this.bcledgerFilter)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data.Data) {
            this.sampleLists = res.data.Data;
            this.total = res.data.Total;
          } else {
            this._toastr.error("Error", res.message ?? "No results found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "No results found");
        },
      });
  }

  moveToFreight() {
    this.display = true;
  }

  moveToFreightStatus(event: boolean) {
    if (event) {
      this.getSampleData();
    }
    this.display = false;
    this.sampleSelected = {} as FreightsData;
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    exportExcel(this.sampleLists, this.fileName);
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.bcledgerFilter = { ...this.bcLedgerStacker };
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
